import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class DraggableSprite extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, name) {
    super(scene, 0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, name);

    DraggableSprite.instances.push(this);

    /** @type {Phaser.GameObjects.Image[]} */
    this.hitTarget = null;
    this.name = name;
    this.enabled = true;
    this.hitListener = null;
    this.outListener = null;
    this.targetIntersected = null;

    this.setInteractive({ draggable: true }).on(Phaser.Input.Events.GAMEOBJECT_DRAG, this.handlePress, this)
      .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick, this)
      .on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.doClickUp(false));
  }

  handlePress (pointer, x, y) {
    if (!this.enabled) return;

    this.x = x;
    this.y = y;
  }

  doClick () {
    if (!this.enabled) return;

    if (this.parentContainer) {
      this.parentContainer.bringToTop(this);
    }
    else {
      this.scene.children.bringToTop(this);
    }

    if (this.targetIntersected) {
      this.targetIntersected.occupied = false;
      this.targetIntersected = null;
    }
  }

  doClickUp(suppressTargetCheck = false) {
    if (!this.enabled) return;

    if (this.hitTarget !== null) {
      let maxAreaCollided = 0;
      let maxAreaTarget = null;

      const topLeft = this.getTopLeft(null, true);
      const thisRect = new Phaser.Geom.Rectangle(topLeft.x, topLeft.y, this.width,this.height);

      if (this.hitTarget.length > 0) {
        for (let i = 0; i < this.hitTarget.length; i++) {
          const target = this.hitTarget[i];

          const targetTopLeft = target.getTopLeft(null, true);
          const targetRect = new Phaser.Geom.Rectangle(targetTopLeft.x, targetTopLeft.y, target.width,target.height);

          const collision = Phaser.Geom.Rectangle.Intersection(thisRect, targetRect);

          if (collision.width > 0 && collision.height > 0) {
            const areaCollided = collision.width * collision.height;

            if (areaCollided > maxAreaCollided) {
              maxAreaCollided = areaCollided;
              maxAreaTarget = target;
            }
          }
        }

        if (maxAreaTarget && !maxAreaTarget.occupied) {
          if (this.hitListener) {
            maxAreaTarget.occupied = true;
            this.targetIntersected = maxAreaTarget;
            if (!suppressTargetCheck) {
              this.hitListener(this, maxAreaTarget);
            }
          }
        }
        else {
          if (!suppressTargetCheck) {
            this.outListener(this);
          }
        }
      }
      else {
        this.outListener(this);
      }
    }

    if (!suppressTargetCheck) {
      // check all draggable Sprite instances to see which targets still occupied
      DraggableSprite.checkTargetsOccupied();
    }
  }

  snapToTarget () {
    if (this.targetIntersected) {
      this.x = this.targetIntersected.x;
      this.y = this.targetIntersected.y;
    }
  }

  enable () {
    this.enabled = true;
    this.alpha = 1;
  }

  disable () {
    this.enabled = false;
    this.alpha = 0.7;
  }

  moveToOriginalPosition () {
    ABCyaPhaser.Tweens.addTween(this, 500, { x: this.originalX, y: this.originalY }, Phaser.Math.Easing.Quadratic.Out);
  }

  /** @type {DraggableSprite[]} */
  static instances = [];

  static checkTargetsOccupied () {
    const len = DraggableSprite.instances.length;
    for (let i = 0; i < len; i++) {
      const thisOne = DraggableSprite.instances[i];
      thisOne.doClickUp(true);
    }
  }

  static checkAllTargetsMatchTiles () {
    const len = DraggableSprite.instances.length;
    let count = 0;
    for (let i = 0; i < len; i++) {
      const thisOne = DraggableSprite.instances[i];
      if (thisOne.targetIntersected) {
        if (thisOne.targetIntersected.number === thisOne.number) {
          count++;
        }
      }
    }

    return count === len;
  }

  static enableAll (type = null) {
    const len = DraggableSprite.instances.length;

    for (let i = 0; i < len; i++) {
      const thisOne = DraggableSprite.instances[i];
      if (thisOne.type === type || type === null) {
        thisOne.enable();
      }
    }
  }

  static disableAll (type = null) {
    const len = DraggableSprite.instances.length;

    for (let i = 0; i < len; i++) {
      const thisOne = DraggableSprite.instances[i];
      if (thisOne.type === type || type === null) {
        thisOne.disable();
      }
    }
  }
}